export function noticeNeedsFocus(notice, reloadProblem) {
  const noticeText = typeof notice === "string" ? notice : "";
  const problemText = typeof reloadProblem === "string" ? reloadProblem : "";
  return noticeText !== "" || problemText !== "";
}
